// @flow
import { useEffect } from 'react';
import scriptLoader, { waitInWindow } from '../helpers/scriptLoader';

const debug = require('debug')('jp:zendeskchat');

const ZendeskChatWidget = () => {
  useEffect(() => {
    debug('Load widget');
    scriptLoader(
      'https://static.zdassets.com/ekr/snippet.js?key=6d9e9cd9-4fc2-4c87-808d-518dbfe1c7fc',
      true,
      true,
      [
        {
          key: 'id',
          value: 'ze-snippet'
        }
      ]
    )
      .then(() => waitInWindow('zE'))
      .then(() => {
        window.zE('webWidget', 'show');
      });

    return () => {
      if ('zE' in window) {
        window.zE('webWidget', 'hide');
        debug('Hide widget');
      }
    };
  }, []);

  return null;
};

export default ZendeskChatWidget;
